/* global _ Vue */
import Form from "acacha-forms";
import VueTelInput from "vue-tel-input";

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
	window._ = require("lodash");
	window.Popper = require("popper.js").default;
	window.$ = window.jQuery = require("jquery");
	window.Form = Form;
	window.moment = require("moment");

	require("./smoothscroll");
	require("bootstrap");
	require("admin-lte");
	require("summernote");
	require("datatables.net-bs");
	require("datatables.net-responsive-bs");
	require("datatables.net-buttons");
	require("icheck");
	require("inputmask");
} catch (e) {}

moment.locale("fr");

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

window.token = document.head.querySelector('meta[name="csrf-token"]');

if (window.token) {
	window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
	console.error(
		"CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
	);
}

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require("vue");
Vue.use(require("uiv"));
Vue.use(VueTelInput);

// Use trans function in Vue (equivalent to trans() Laravel Translations helper). See htmlheader.balde.php partial.
Vue.prototype.trans = key => {
	return _.get(window.trans, key, key);
};

// Laravel AdminLTE vue components
Vue.component("register-form", require("./components/auth/RegisterForm.vue").default);
Vue.component("login-form", require("./components/auth/LoginForm.vue").default);
Vue.component(
	"email-reset-password-form",
	require("./components/auth/EmailResetPasswordForm.vue")
	.default
);
Vue.component(
	"reset-password-form",
	require("./components/auth/ResetPasswordForm.vue")
	.default
);
